import { FC } from 'react';

export const InlineLoader: FC = () => (
  <span
    aria-label="loading"
    className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-current border-t-transparent text-slate-200"
  />
);
